import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posSalesWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.sales",
  name: "POS sales",
  description: "POS sales for the selected dashboard period.",
  apps: [
    "point-of-sale",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "pos.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total_amount",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "status",
        operator: "eq",
        value: "paid",
      },
    },
  },
  inputs: {
    label: "Sales",
    subtext: "in the last 30 days",
    icon: "money",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$32,840",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
